import React, { FunctionComponent } from 'react'

import { RelatedResources } from './RelatedResources'
import { RelatedVideosPlaylist } from './RelatedVideosPlaylist'
import { RelatedResource, Video } from '../utils/common'

interface VideoSidePanelProps {
  relatedVideos: Video[]
  relatedResources: RelatedResource[]
}

export const VideoSidePanel: FunctionComponent<VideoSidePanelProps> = ({
  relatedVideos,
  relatedResources,
}) => (
  <div className="videoPageSidePanel" data-testid="video-side-panel">
    {relatedVideos.length ? (
      <RelatedVideosPlaylist
        title="Getting Started with PayPal"
        videos={relatedVideos}
      />
    ) : null}
    <RelatedResources resources={relatedResources} />
  </div>
)
